import { useState } from 'react';
import PresentationContainer from 'react-presentation-container';

import pick from 'lodash/pick';

import UserService from '@/services/user.service';
import AffiliateService from '@/services/affiliate.service';

import OrganizationModal from './OrganizationModal.component';
import { useQuery } from 'react-query';
import OrganizationService from '@/services/organization.service';

export default PresentationContainer({
  component: OrganizationModal,
  middleware: [],
  controller: function OrganizationModalController({ onSubmit, organization }) {
    const { data } = useQuery('OrganizationService.read', () => OrganizationService.read());
    const [formState, setFormState] = useState({
      values: pick(organization, ['name', 'affiliate', 'user']),
    });

    const handleGetUsers = async () => {
      const users = await UserService.readAll();
      return users.filter(
        (user) => !data.some((org) => org.user.id === user.id) || organization?.user?.id === user.id,
      );
    };
    const handleGetUserLabel = ({ firstName, lastName, email }) =>
      `${firstName} ${lastName} [${email}]`;
    const handleGetUserSelected = ({ id: optionId }, { id: valueId }) => optionId === valueId;

    const handleGetAffiliates = async () => {
      const affiliates = await AffiliateService.read();
      return affiliates.filter(
        (affiliate) =>
          !data.some((org) => org.affiliate.id === affiliate.id) ||
          organization?.affiliate?.id === affiliate.id,
      );
    };
    const handleGetAffiliateLabel = ({ code }) => code;
    const handleGetAffiliateValue = ({ id: optionId }, { id: valueId }) => optionId === valueId;
    const handleSubmit = ({ values, validationState }) => {
      if (!validationState.valid) {
        return;
      }

      onSubmit && onSubmit(values);
    };

    const handleFormChange = (state) => setFormState(state);

    return {
      formState,
      handleGetUsers,
      handleGetUserLabel,
      handleGetUserSelected,
      handleGetAffiliates,
      handleGetAffiliateLabel,
      handleGetAffiliateValue,
      handleSubmit,
      handleFormChange,
    };
  },
});
